import request from '@/utils/request'

export function legacySchema(module) { return request({ url: `/dkmall/legacy/${module}/schema`, method: 'get' }) }
export function legacyPage(module, params) { return request({ url: `/dkmall/legacy/${module}`, method: 'get', params }) }
export function legacyDetail(module, id) { return request({ url: `/dkmall/legacy/${module}/${id}`, method: 'get' }) }
export function addLegacy(module, data) { return request({ url: `/dkmall/legacy/${module}`, method: 'post', data }) }
export function updateLegacy(module, data) { return request({ url: `/dkmall/legacy/${module}`, method: 'put', data }) }
export function deleteLegacy(module, id) { return request({ url: `/dkmall/legacy/${module}/${id}`, method: 'delete' }) }
